import { Component, createRef } from "react";
//Import Components
import MainPagetitle from "../../layouts/MainPagetitle";
import ProductCard from "./elements/ProductCard";
import { Image } from "antd";
class ConnectorHome extends Component {
  constructor(props) {
    super(props);
    this.changePasswordModalRef = createRef();

    props.initialconstruct.bind(this)();
    this.state = {
      data: [],
      myinfo: [],
      dashboardData: [],
      userInitials: "",
    };
    this.columns = [
      {
        dataIndex: "name",
        title: "Name",
        render: (text) => {
          return <span className="text-primary">{text}</span>;
        },
      },
      {
        dataIndex: "mobileNumber",
        title: "Mobile No.",
      },
      {
        dataIndex: "productType",
        title: "Product Type",
      },
      {
        dataIndex: "date",
        title: "Enquire Date",
        render: (text) => {
          let date = new Date(text).dateToDDMMYYYY(new Date(text));
          return date;
        },
      },
      {
        dataIndex: "status",
        title: "Status",
      },
    ];
    this.isPanVerified = this.props.$store?.user?.is_pan_code_verified;
    this.isAadharVerified = this.props.$store?.user?.is_aadhar_verified;
    this.is_agreement_signed = this.props.$store?.user?.is_agreement_signed;

    this.featured = [
      {
        title: "Verify PAN",
        image: imagepaths.panNewIcon,
        buttonType: "active",
        buttonText: "Verify",
        path: "/app/kyc",
      },
      {
        title: "Verify Aadhar",
        image: imagepaths.aadharNewIcon,
        buttonType: "active",
        buttonText: "Verify",
        path: "/app/kyc",
      },
      {
        title: "Bank Statement",
        image: imagepaths.dollarFileIcon,
        buttonType: "active",
        buttonText: "Verify",
      },
      {
        title: "Digital Flows",
        image: imagepaths.blueMonitorIcon,
        buttonType: "active",
        buttonText: "Verify",
      },
      {
        title: "Digital Applications",
        image: imagepaths.threeFilterIcon,
        buttonType: "active",
        buttonText: "Verify",
        path: "/app/businesstobusiness?activetab=digitalleads",
      },
      {
        title: "Credit Score",
        image: imagepaths.meterScoreIcon,
        buttonType: "inactive",
        buttonText: "Coming Soon",
      },
    ];
  }

  componentDidMount() {
    this.getConnectorDetails();

    if (
      !this.isPanVerified ||
      !this.isAadharVerified ||
      !this.is_agreement_signed
    ) {
      swal2
        .fire({
          title: "Account Verification Pending",
          text: "Please complete your profile",
          icon: "info",
          iconColor: "#234C9B",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.props.navigate("/app/myprofile");
          }
        });
    }
  }

  getInitials(name) {
    if (!name) return "";

    const words = name.trim().split(" ");

    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }

    return (words[0][0] + words[1][0]).toUpperCase();
  }

  getAvatar(fileId) {
    let authToken = this.props.$store.auth;
    let url = this.props.apis.apiGetFileThumnail(
      { auth: authToken },
      { fileId: fileId }
    );
    return url;
  }

  getConnectorDetails() {
    this.props.apis.apiGetConnectorDetails().then((res) => {
      if (res?.photoFileId) {
        let profileUrl = this.getAvatar(res?.photoFileId);
        this.setState({
          myinfo: { ...res, profileUrl },
          userInitials: this.getInitials(res?.name),
        });
      }
    });
  }
  render() {
    let { featured, isPanVerified, isAadharVerified, is_agreement_signed } =
      this;
    let { dashboardData, data, myinfo, userInitials } = this.state;
    return (
      <>
        <MainPagetitle
          mainTitle="Dashboard"
          pageTitle="Dashboard"
          parentTitle="Home"
        />

        {isPanVerified && isAadharVerified && is_agreement_signed ? (
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div className="info_card">
                      <div className="row">
                        <div className="col-12 col-md-2">
                          <div className="avatar_card">
                            {myinfo?.profileUrl ? (
                              <Image
                                width={200}
                                preview={false}
                                src={myinfo?.profileUrl}
                              />
                            ) : (
                              <div className="initial_box">
                                <h2>{userInitials}</h2>
                              </div>
                            )}
                            <h4 className="title text-white mb-1">
                              {myinfo?.name || "-"}
                            </h4>
                            <p>
                              {_enum.ROUTE_PERSONAS_MAP[myinfo?.role] ||
                                _enum.ROUTE_PERSONAS_MAP[
                                  this.props?.$store?.user?.role
                                ] ||
                                "-"}
                            </p>
                          </div>
                        </div>
                        <div className="col-12 col-md-10">
                          <div className="content">
                            <ul className="content_ul content_centered">
                              <li>
                                <span className="li_label">Employee ID</span>
                                <span className="li_value">
                                  {myinfo?.profileId || "-"}
                                </span>
                              </li>
                              <li>
                                <span className="li_label">Mobile No</span>
                                <span className="li_value">
                                  {myinfo?.mobileNumber || "-"}
                                </span>
                              </li>
                              <li>
                                <span className="li_label">Email ID</span>
                                <span className="li_value">
                                  {myinfo?.emailAddress || "-"}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <div className="tbl-caption-container">
                      <h4 className="mb-0">Featured</h4>
                    </div>
                    <div className="row mx-auto g-3 px-3 mb-5">
                      {featured &&
                        featured.map((item, i) => {
                          return (
                            <ProductCard
                              key={i}
                              title={item.title}
                              desc={item.desc}
                              image={item.image}
                              buttonType={item.buttonType}
                              buttonText={item.buttonText}
                              path={item.path}
                              // handleProduct={props.handleProduct}
                            />
                          );
                        })}
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }
}
export default constore(ConnectorHome);
